// actions.js
// export const SET_FULL_NAME = "SET_FULL_NAME";
export const SET_FIRSTNAME = "SET_FIRSTNAME";
export const SET_LASTNAME = "SET_LASTNAME";
export const SET_DBA = "SET_DBA";
export const SET_ORG_FULL_NAME = "SET_ORG_FULL_NAME";
export const SET_ORG_CATEGORY = "SET_ORG_CATEGORY";
export const SET_STREET_ADRESS = "SET_STREET_ADRESS";
export const SET_CITY = "SET_CITY";
export const SET_STATE = "SET_STATE";
export const SET_ZIP_CODE = "SET_ZIP_CODE";
export const SET_COUNTRY = "SET_COUNTRY";
export const SET_APT = "SET_APT";
export const SET_PHONE = "SET_PHONE";
export const TEACHING_PAGE_URL = "TEACHING_PAGE_URL";
export const ALREADY_TEACHING_ONLINE = "ALREADY_TEACHING_ONLINE";
export const STUDENTS_CSV = "STUDENTS_CSV";
export const PAYMENT_PERIOD = "PAYMENT_PERIOD";
export const PACKAGE_TYPE = "PACKAGE_TYPE";
export const TEACHING_TYPE = "TEACHING_TYPE";
export const ADDRESS_TYPE = "ADDRESS_TYPE";
export const ERROR = "ERROR";

// export const setFullName = (fullName) => {
//   return {
//     type: SET_FULL_NAME,
//     payload: fullName,
//   };
// };
export const setFirstName = (firstName) => {
  return {
    type: SET_FIRSTNAME,
    payload: firstName,
  };
};
export const setLastName = (lastName) => {
  return {
    type: SET_LASTNAME,
    payload: lastName,
  };
};

export const setDba = (dba) => {
  return {
    type: SET_DBA,
    payload: dba,
  };
};
export const setOrgFullName = (orgFullName) => {
  return {
    type: SET_ORG_FULL_NAME,
    payload: orgFullName,
  };
};
export const setOrgCategory = (orgCategory) => {
  return {
    type: SET_ORG_CATEGORY,
    payload: orgCategory,
  };
};
export const setStreetAdress = (streetAdress) => {
  return {
    type: SET_STREET_ADRESS,
    payload: streetAdress,
  };
};
export const setCity = (city) => {
  return {
    type: SET_CITY,
    payload: city,
  };
};
export const setState = (state) => {
  return {
    type: SET_STATE,
    payload: state,
  };
};
export const setZipCode = (zipCode) => {
  return {
    type: SET_ZIP_CODE,
    payload: zipCode,
  };
};
export const setCountry = (country) => {
  return {
    type: SET_COUNTRY,
    payload: country,
  };
};
export const setApt = (apt) => {
  return {
    type: SET_APT,
    payload: apt,
  };
};
export const setTeachingPageUrl = (teachingPageUrl) => {
  return {
    type: TEACHING_PAGE_URL,
    payload: teachingPageUrl,
  };
};
export const setAlreadyTeachingOnline = (alreadyTeachingOnline) => {
  return {
    type: ALREADY_TEACHING_ONLINE,
    payload: alreadyTeachingOnline,
  };
};
export const setStudentsCSV = (studentsCSV) => {
  return {
    type: STUDENTS_CSV,
    payload: studentsCSV,
  };
};
export const setPaymentPeriod = (paymentPeriod) => {
  return {
    type: PAYMENT_PERIOD,
    payload: paymentPeriod,
  };
};
export const setPackageType = (packageType) => {
  return {
    type: PACKAGE_TYPE,
    payload: packageType,
  };
};
export const setTeachingType = (teachingType) => {
  return {
    type: TEACHING_TYPE,
    payload: teachingType,
  };
};
export const setAddressType = (addressObj) => {
  return {
    type: ADDRESS_TYPE,
    payload: addressObj,
  };
};
export const setError = (error) => {
  return {
    type: ERROR,
    payload: error,
  };
};
